import React from 'react';
import ZoomInButton from 'assets/ZoomInButton';
import ZoomOutButton from 'assets/ZoomOutButton';
import styles from './ZoomButtons.module.scss';

type ZoomButtonsProps = {
    zoomIn: () => void;
    zoomOut: () => void
}

const ZoomButtons: React.FC<ZoomButtonsProps> = ({zoomIn, zoomOut}) => (
    <div className={styles.ZoomButtons}>
        <ZoomInButton onClick={zoomIn} />
        <ZoomOutButton onClick={zoomOut} />
    </div>
)

export default ZoomButtons;